// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3lrfh","boxTitle":"Qualiphy_boxTitle__1vQ8I","box":"Qualiphy_box__2Oca3","toggleWrap":"Qualiphy_toggleWrap__2iVgK"};